import clsx from 'clsx';
import React from 'react';
import { theme } from '../../utils';
import styles from './ImageContentBlock.module.scss';
const renderImageContent = (content, imageUrl, mobileImageUrl, videoUrl) => {
    return (<>
      {imageUrl && (<div className={styles.blockImage}>
          {mobileImageUrl ? (<picture>
              <source media={`(min-width:${theme.constants.md})`} srcSet={imageUrl}/>
              <source media={`(min-width:${theme.constants.xs})`} srcSet={mobileImageUrl}/>
              <img src={imageUrl} alt=''/>
            </picture>) : (<img src={imageUrl} alt=''/>)}
        </div>)}
      {videoUrl && (<div className={styles.blockVideo}>
          <video controls>
            <source src={videoUrl} type='video/mp4'/>
            Your browser does not support the video tag.
          </video>
        </div>)}
      {content && <div className={styles.blockContent}>{content}</div>}
    </>);
};
export const ImageContentBlock = ({ title, content, imageUrl, mobileImageUrl, contentColumns, reversed, vertical, gutterBottom, gutterTop, videoUrl, }) => {
    return (<>
      {!!title && <h2>{title}</h2>}
      <div className={clsx('owners-body', styles.block, reversed && styles.reversed, vertical && styles.vertical, gutterBottom && styles.gutterBottom, gutterTop && styles.gutterTop)}>
        {(contentColumns === null || contentColumns === void 0 ? void 0 : contentColumns.length) &&
            React.Children.toArray(contentColumns.map((column) => (<div className={styles.blockColumn}>
                {renderImageContent(column.content, column.imageUrl, column.mobileImageUrl, videoUrl)}
              </div>)))}

        {(content || imageUrl || videoUrl) &&
            renderImageContent(content, imageUrl, mobileImageUrl, videoUrl)}
      </div>
    </>);
};
